import { dataSource } from '../service/domain/_service.config'

export interface ErrorLogContext {
  [key: string]: unknown
}

/**
 * Sends an error report to the error_logs table so devs can debug
 * without needing Vercel access. Safe to call from anywhere (catch blocks,
 * ErrorBoundary). Failures are ignored so logging never throws.
 */
export async function logError(
  error: unknown,
  context?: ErrorLogContext,
  source?: string,
  caller?: string,
): Promise<void> {
  const message = error instanceof Error ? error.message : String(error)
  const stack = error instanceof Error ? error.stack ?? null : null

  const mergedContext: Record<string, unknown> = context ? { ...context } : {}
  if (caller) mergedContext.caller = caller

  await dataSource.logError({
    message,
    stack: stack ?? undefined,
    context: Object.keys(mergedContext).length > 0 ? mergedContext : undefined,
    source: source ?? 'client',
  })
}
